import { useEffect, useRef, useState } from "react";
import { useUser } from "../../context/UserContext";
import CopyIcon from "../../icon/CopyIcon";
import PencilEditIcon from "../../icon/PencilEditIcon";
import CommonButton from "../../ui/CommonButton";
import ChallengeSteps from "../ChallengeSteps/ChallengeSteps";
import classes from "./Profile.module.css";
import axios from "axios";
import { env } from "../../constants/env";
import { use } from "react";
import { toast } from "react-toastify";
import useWindowDimensions from "../../hooks/getWindowDimensions";
import PurchaseOptions from "../PurchaseOptions/PurchaseOptions";
import { parsePrice, stripePromise } from "../Trading/Trading";
import { Elements } from "@stripe/react-stripe-js";
import SuccessPage from "../SuccessPage/SuccessPage";
import HowItWorks from "../HowItWorks/HowItWorks";
import ChallengeEnrollment from "../ChallengeEnrollment/ChallengeEnrollment";

const token = localStorage.getItem("userToken");

const Profile = ({showPurchase, setShowPurchase}) => {
  const { user, fetchUserData } = useUser();

  const [copyStatus, setCopyStatus] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(user?.name);
  // const [showPurchase, setShowPurchase] = useState(false);
  const [activeAccountType, setActiveAccountType] = useState("10K");
  const [accountTypeAmount, setAccountTypeAmount] = useState("$100.00");

  const { height, width } = useWindowDimensions();

  const inputRef = useRef(null);

  // Dynamically adjust the width based on the input content
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.width = `${inputRef.current.scrollWidth}px`;
    }
  }, [name]); // Adjust width whenever the name changes

  useEffect(() => {
    setName(user?.name);
  }, [user]);

  // Handle clicking on the name to start editing
  const handleEditClick = () => {
    setIsEditing(true);
  };

  // Handle losing focus (blur event)
  const handleBlur = () => {
    saveName();
  };

  // Handle changing the name input
  const handleChange = (e) => {
    setName(e.target.value);
  };

  const saveName = async () => {
    setIsEditing(false);
    try {
      const response = await axios.put(
        `${env.apiUrl}/api/user/update-name`,
        { name }, // Ensure 'name' is part of the body
        {
          headers: {
            "Content-Type": "application/json", // Proper JSON header
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Name updated:", response.data);
      fetchUserData();
    } catch (error) {
      console.error("Error updating name:", error);
      alert("Failed to update name. Please try again.");
    }
  };

  const accountInfoList = [
    {
      title: "Account type",
      desc: user?.account?.accountType,
    },
    {
      title: "Account ID",
      desc: user?.account?.accountId ? user?.account?.accountId : "",
    },
    // {
    //   title: "Referral code",
    //   desc: `${env.siteUrl}?referral-code=${user?.referralCode}`,
    // },
    // {
    //   title: "Referral link",
    //   desc: "Coming soon",
    // },
  ];

  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("avatar", file);
    try {
      const response = await axios.post(
        `${env.apiUrl}/api/user/upload-avatar`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      fetchUserData();
      console.log(response.data.user);
    } catch (error) {
      console.error("Error uploading avatar:", error);
      alert("Failed to upload avatar. Please try again.");
    }
  };

  const handleCopy = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopyStatus("Text copied!");
      toast.success("Link copied!");
    } catch (err) {
      console.error("Failed to copy text: ", err);
      setCopyStatus("Failed to copy text.");
    }
  };

  return showPurchase ? (
    <ChallengeEnrollment setShowPurchase={setShowPurchase} activeAccountType={activeAccountType} />
    // <Elements stripe={stripePromise}>
    //   <PurchaseOptions
    //     setShowPurchase={(value) => setShowPurchase(value)}
    //     challengeTitle={`$${activeAccountType}`}
    //     challengePrice={parsePrice(accountTypeAmount)}
    //   />
    // </Elements>
  ) : (
    <div className={classes.wrapper}>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <div className="d-flex align-items-center gap-3 ">
            <div
              className={classes.avatarContainer}
              style={{ backgroundImage: `url(${env.apiUrl}${user?.avatar})` }}
            >
              <div
                className={`d-flex justify-content-center align-items-center ${classes.editContainer}`}
              >
                {/* Hidden file input */}
                <input
                  type="file"
                  id="fileInput"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                  ref={fileInputRef} // Reference to reset the input
                />

                {/* Label acts as a clickable icon */}
                <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
                  <PencilEditIcon color="#CECECE" height={12} width={13} />
                </label>
              </div>
            </div>
            <div className={classes.userInfo}>
              <div>
                {isEditing ? (
                  <input
                    type="text"
                    value={name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    ref={inputRef} // Reference for dynamic width adjustment
                  />
                ) : (
                  <div
                    className="d-flex align-items-center gap-2"
                    onClick={handleEditClick}
                    style={{ cursor: "pointer" }}
                  >
                    <h3>{user?.name}</h3>{" "}
                    <PencilEditIcon color="#FFFFFF" height={17} width={18} />
                  </div>
                )}
              </div>

              <div className="d-flex align-items-center gap-2">
                <h5>{user?.email}</h5>
              </div>
            </div>
          </div>
          <div
            className={`d-flex ${classes.accountInfo} justify-content-md-start justify-content-between flex-wrap`}
          >
            {accountInfoList.map((item, i) => (
              <div
                key={i}
                className={i === 1 && width > 768 ? classes.addRightMargin : ""}
              >
                <h6 className={classes.titleText}>{item.title}</h6>
                <div className="d-flex gap-3">
                  <h6 className={i === 2 ? classes.comingSoonText : ""}>
                    {item.desc}
                  </h6>
                  {/* {i === 2 && <CopyIcon color="#fff"  onClick={() => handleCopy(item.desc)} />} */}
                </div>
              </div>
            ))}
          </div>
          {/* {width <= 768 && (
            <div className={`d-flex align-items-center gap-3 my-4`}>
              <CommonButton
                text="Purchase"
                onClick={() => setShowPurchase(true)}
              />
              <CommonButton text="Docs" className={classes.commonButtonBg} />
            </div>
          )} */}
        </div>
        {/* {width > 768 && (
          <div className="d-flex align-items-center gap-3">
            {user?.account?.accountType === "Explorer"  || user?.account?.hasFailed && (
              <CommonButton
                text="Purchase"
                onClick={() => setShowPurchase(true)}
              />
            )}
            <a href="https://docs.proptrading.fun/" target="_blank">
              <CommonButton text="Docs" className={classes.commonButtonBg} />
            </a>
          </div>
        )} */}
      </div>
      {(user?.account?.accountType === "Explorer" || user?.account?.hasFailed) ? (
        <ChallengeSteps
          className={classes.stepsContainer}
          activeAccountType={activeAccountType}
          setShowPurchase={(value) => setShowPurchase(value)}
          setActiveAccountType={(value) => setActiveAccountType(value)}
          setAccountTypeAmount={(value) => setAccountTypeAmount(value)}
          showFooter
        />
       ) : (<HowItWorks className="mt-5" />)}
    </div>
  );
};

export default Profile;
